export enum RolesTypes {
  SUPER_ADMIN = "SuperAdmin",
  ADMIN = "Administrador",
  TECHNICAL = "Técnico",
}

export const ROLES_OPTIONS = [
  RolesTypes.SUPER_ADMIN,
  RolesTypes.ADMIN,
  RolesTypes.TECHNICAL,
];
